import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { ItemLabelModel } from '../../../../../../shared/components/dropdown/models/dropdown-props.model';
import { optionEquality } from '../../../../../../shared/utils/option-equality/option-equality.util';
import { mapStatisticsFilterOptionsToItemLabelModel } from '../../../utils/mapping/mapping.util';
import { filterConfigMock } from '../mocks/filter-config.mock';
import { StatisticsFilterProps } from '../types/statistics-filter-props.type';

const DisplayDropdown: FunctionComponent<StatisticsFilterProps> = (
  props: PropsWithChildren<StatisticsFilterProps>
) => {
  const { setFieldValue, errors, touched } = props;
  const options = filterConfigMock.display;

  return (
    <FormControl
      key="statistics-display"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="display"
        isOptionEqualToValue={optionEquality}
        onChange={(event, value) => {
          const val = value as ItemLabelModel<string>;
          setFieldValue('display', val);
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="display"
            label="Display"
            name="display"
            errors={errors}
            touched={touched}
          />
        )}
        options={options.map(mapStatisticsFilterOptionsToItemLabelModel)}
      />
    </FormControl>
  );
};

export default DisplayDropdown;
